import React, { Component, Fragment } from 'react';

import { DocumentFieldText } from 'components/cards/document/preview/DocumentFieldText';
import { DefinitionField } from 'components/common/fields/DefinitionField';
import FieldsGroup from 'components/cards/document/fields/FieldsGroup';
import { strToDate } from 'mappers/commonMapper';
import { getValue, xmlArrayToObj, checkGroup } from 'helpers/documentsHelpers';
import { cardEdited } from '../fields/CardEdited';

export default class InterviewRecruiter extends Component {
    personImpression = checkGroup(({ appearance, qualities, language }) => (
        <FieldsGroup translate="personImpression">
            <DefinitionField translate="xml.PplInterv.PersonalAppearance" show={!!appearance}>
                <DocumentFieldText
                    name="xml.PplInterv.PersonalAppearance"
                    value={appearance}
                />
            </DefinitionField>
            <DefinitionField translate="xml.PplInterv.PersonalQualities" show={!!qualities}>
                <DocumentFieldText
                    name="xml.PplInterv.PersonalQualities"
                    value={qualities}
                />
            </DefinitionField>
            <DefinitionField translate="xml.PplInterv.LanguageSkills" show={!!language}>
                <DocumentFieldText
                    name="xml.PplInterv.LanguageSkills"
                    value={language}
                />
            </DefinitionField>
        </FieldsGroup>
    ))

    profExperience = checkGroup(({ differenceFromCV, experience }) => (
        <FieldsGroup translate="profExperience">
            <DefinitionField translate="xml.PplInterv.DifFromCV" show={!!differenceFromCV}>
                <DocumentFieldText
                    name="xml.PplInterv.DifFromCV"
                    value={differenceFromCV}
                />
            </DefinitionField>
            <DefinitionField translate="xml.PplInterv.ProfessionalExperience" show={!!experience}>
                <DocumentFieldText
                    name="xml.PplInterv.ProfessionalExperience"
                    value={experience}
                />
            </DefinitionField>
        </FieldsGroup>
    ))

    salary = checkGroup(({ salary }) => (
        <FieldsGroup translate="salary">
            <DocumentFieldText
                name="xml.PplInterv.WantSalary"
                value={salary}
            />
        </FieldsGroup>
    ))

    profMotivation = checkGroup(({ motivation }) => (
        <FieldsGroup translate="profMotivation">
            <DocumentFieldText
                name="xml.PplInterv.ProfessionalMotivation"
                value={motivation}
            />
        </FieldsGroup>
    ))

    jobSearchHistory = checkGroup(({ jobSearchHistory }) => (
        <FieldsGroup translate="jobSearchHistory">
            <DocumentFieldText
                name="xml.PplInterv.JobSearchHistory"
                value={jobSearchHistory}
            />
        </FieldsGroup>
    ))

    interviewConsolution = checkGroup(({ wherePresent, whereEfficient }) => (
        <FieldsGroup translate="interviewConsolution">
            <DefinitionField translate="xml.PplInterv.WherePresent" show={!!wherePresent}>
                <DocumentFieldText
                    name="xml.PplInterv.WherePresent"
                    value={wherePresent}
                />
            </DefinitionField>
            <DefinitionField translate="xml.PplInterv.WhereEfficient" show={!!whereEfficient}>
                <DocumentFieldText
                    name="xml.PplInterv.WhereEfficient"
                    value={whereEfficient}
                />
            </DefinitionField>
        </FieldsGroup>
    ))

    additionalComments = checkGroup(({ comments }) => (
        <FieldsGroup translate="additionalComments">
            <DocumentFieldText
                name="xml.PplInterv.DopInfo"
                value={comments}
            />
        </FieldsGroup>
    ))

    alsoParticipated = checkGroup(({ alsoParticipated }) => (
        <FieldsGroup translate="alsoParticipated">
            <DocumentFieldText
                name="xml.PplInterv.AlsoParticipated"
                value={alsoParticipated}
            />
        </FieldsGroup>
    ))

    render() {
        const { xml } = this.props;
        const xmlObject = xmlArrayToObj(xml);

        return (
            <Fragment>
                {this.personImpression({
                    appearance: getValue(xmlObject.PersonalAppearance),
                    qualities: getValue(xmlObject.PersonalQualities),
                    language: getValue(xmlObject.LanguageSkills)
                })}
                {this.profExperience({
                    differenceFromCV: getValue(xmlObject.DifFromCV),
                    experience: getValue(xmlObject.ProfessionalExperience)
                })}
                {this.salary({
                    salary: getValue(xmlObject.WantSalary)
                })}
                {this.profMotivation({
                    motivation: getValue(xmlObject.ProfessionalMotivation)
                })}
                {this.jobSearchHistory({
                    jobSearchHistory: getValue(xmlObject.JobSearchHistory)
                })}
                {this.interviewConsolution({
                    wherePresent: getValue(xmlObject.WherePresent),
                    whereEfficient: getValue(xmlObject.WhereEfficient)
                })}
                {this.alsoParticipated({
                    alsoParticipated: getValue(xmlObject.AlsoParticipated)
                })}
                {this.additionalComments({
                    comments: getValue(xmlObject.DopInfo)
                })}
                {cardEdited({
                    documentUpdateDate: strToDate(getValue(xmlObject.whenchange)),
                    documentUpdatePerson: getValue(xmlObject.whochange),
                    documentLettersUpdate: getValue(xmlObject.howmanylettersadded)
                })}
            </Fragment>
        );
    }
}
